import { AmbientLight, Color, DirectionalLight, HemisphereLight } from 'three';

import { SunManager } from '../sun-manager';
import { HexColor, Position3, ReportLighting } from './manifest';

const toHex = (color: Color): HexColor => `#${color.getHexString()}`;

/**
 * Gets the lights the viewer shades faces with: the directional and hemisphere lights with the sun
 * direction on, otherwise the ambient light.
 */
export function getReportLighting(): ReportLighting {
  const lighting: ReportLighting = { directional: [], hemisphere: [], ambient: [] };

  for (const light of SunManager.instance.cloneLights()) {
    if (light instanceof DirectionalLight) {
      // Local and world coordinates only differ by the origo, so directions are the same.
      const direction = light.position.clone().sub(light.target.position).normalize();
      lighting.directional.push({
        direction: direction.toArray() as Position3,
        color: toHex(light.color),
        intensity: light.intensity,
      });
    } else if (light instanceof HemisphereLight) {
      lighting.hemisphere.push({
        skyColor: toHex(light.color),
        groundColor: toHex(light.groundColor),
        intensity: light.intensity,
      });
    } else if (light instanceof AmbientLight) {
      lighting.ambient.push({ color: toHex(light.color), intensity: light.intensity });
    }
  }

  return lighting;
}
